module.exports = ".k-button {\n  margin-left: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/filters/row/multi-select/multi-select.component.scss
// module id = ./libs/chassis-datatable/src/components/filters/row/multi-select/multi-select.component.scss
// module chunks = main